/* Hall Of Fan Platform UI v1.0 */
(() => {
  'use strict';

  const PATH_HINTS = [
    '/pages/hall-of-fan',
    '/pages/hof-',
    '/pages/fanscore',
    '/pages/fan-score',
    '/pages/fanworks',
    '/pages/fan-guild',
    '/pages/game-center',
    '/pages/halloffan'
  ];

  const ROOT_SELECTOR = [
    '[data-hof-root]',
    '[data-hofg-root]',
    '[data-hof-live-network]',
    '[data-hof-live]',
    '[data-fanworks-root]',
    '[data-fanscore-portal]',
    '.hof-app',
    '.hof-live-network',
    '.fw-shell',
    '.hofg'
  ].join(',');

  const CARD_SELECTOR = [
    '.hof-card',
    '.hof-net-card',
    '.hof-net-event',
    '.hofg__action-card',
    '.hofg__idea-card',
    '.hofg__pulse-card',
    '.hofg__meeting-card',
    '.hofg__rep-card',
    '.fw-panel',
    '.fw-upload-card',
    '.fs-card',
    '.fs-metric',
    '.dashboard-card',
    '.portal-card',
    '.stat-card'
  ].join(',');

  const PRIMARY_SELECTOR = [
    '.hof-primary-button',
    '.hof-net-btn.gold',
    '.hofg__submit-btn',
    '.fw-primary',
    '.fw-upload-button',
    '.fs-btn-primary'
  ].join(',');

  const SECONDARY_SELECTOR = [
    '.hof-secondary-button',
    '.hof-net-btn:not(.gold)',
    '.fw-secondary',
    '.fs-btn-dark'
  ].join(',');

  const isPlatformPath = () => {
    const path = location.pathname.toLowerCase();
    return PATH_HINTS.some(hint => path.includes(hint));
  };

  const hasPlatformRoot = () => !!document.querySelector(ROOT_SELECTOR);

  const isPlatformPage = () => isPlatformPath() || hasPlatformRoot();

  const currentTeam = () => {
    try {
      return JSON.parse(localStorage.getItem('hof_team_theme_v1') || 'null');
    } catch (_) {
      return null;
    }
  };

  const applyTeamColors = () => {
    const root = document.documentElement;
    const saved = currentTeam();
    const source = document.querySelector('[data-team-primary],[data-school-primary],[data-primary-color]');
    const primary = source?.dataset.teamPrimary || source?.dataset.schoolPrimary || source?.dataset.primaryColor || saved?.primary;
    const accent = source?.dataset.teamAccent || source?.dataset.schoolAccent || source?.dataset.accentColor || saved?.secondary;
    if (primary) root.style.setProperty('--school-primary', primary);
    if (accent) root.style.setProperty('--school-accent', accent);
  };

  const classify = () => {
    const body = document.body;
    if (!body) return;

    let type = 'hall-of-fan';
    if (document.querySelector('[data-hof-live][data-role="screen"]')) type = 'live-screen';
    else if (document.querySelector('[data-hof-live][data-role="player"]')) type = 'live-player';
    else if (document.querySelector('[data-hof-live-network]')) type = 'live-network';
    else if (document.querySelector('[data-fanworks-root]')) type = 'fanworks';
    else if (document.querySelector('[data-hofg-root]')) type = 'fan-guild';
    else if (document.querySelector('[data-fanscore-portal],.fs,[id^="fs-"]')) type = 'fanscore';
    else if (document.querySelector('[data-hof-root],.hof-app')) type = 'hall-of-fan';

    body.dataset.hofPlatformSurface = type;

    const appShell = ['live-network','live-screen','live-player','fanworks','fan-guild','fanscore','hall-of-fan'].includes(type) && hasPlatformRoot();
    body.classList.toggle('hof-platform-app-shell', appShell);
  };

  const decorate = () => {
    document.querySelectorAll(CARD_SELECTOR).forEach(el => el.setAttribute('data-hofx-card', ''));
    document.querySelectorAll(PRIMARY_SELECTOR).forEach(el => el.setAttribute('data-hofx-primary', ''));
    document.querySelectorAll(SECONDARY_SELECTOR).forEach(el => el.setAttribute('data-hofx-secondary', ''));

    document.querySelectorAll('.hof-nav button').forEach(btn => {
      const active = btn.classList.contains('is-active') || btn.getAttribute('aria-current') === 'page';
      btn.dataset.hofActive = active ? 'true' : 'false';
    });
  };

  const activate = () => {
    if (!isPlatformPage()) return false;
    document.documentElement.classList.add('hof-platform-ui-html');
    if (!document.body) return false;
    document.body.classList.add('hof-platform-ui');
    document.body.dataset.hofPlatformUi = 'v1.0';
    applyTeamColors();
    classify();
    decorate();
    return true;
  };

  const start = () => {
    let active = activate();
    let queued = false;

    const rerun = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        if (!active) active = activate();
        if (active) {
          applyTeamColors();
          classify();
          decorate();
        }
      });
    };

    const observer = new MutationObserver(rerun);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class','style','aria-current','data-team-primary','data-team-accent','data-school-primary','data-school-accent']
    });

    window.addEventListener('storage', rerun, { passive: true });
    document.addEventListener('fanscore:team-change', rerun);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
